/**
 * Calls `pendo.initialize({visitor, account})` with the backend-provided Pendo payload.
 *
 * NOTE: As of TECH-11594, the backend emits an enriched `pendoVisitor` (with `country`,
 * and for participants: `esopPlan`, `missingParticipantIra`, `missingParticipantTsa`,
 * `eligibleForNlira`, `accountCreationDate`). These flow through unchanged — Pendo
 * accepts the enriched payload on `initialize()`. Non-participant users still receive
 * their base visitor shape (the new fields are null-filtered server-side).
 *
 * Used by: Admin, Client, Advisor, NextLevel Account Holder, National Registry portals.
 * The participant portal migrated to {@link ./identifyPendo.js} in TECH-11594.
 * Future ticket: migrate remaining portals to the two-step `initialize({}) → identify(...)` pattern.
 */
function notifyPendo(user) {
  if (!user) return;

  let pendoVisitor = user.pendoVisitor;
  let pendoAccount = user.pendoAccount;

  if (pendoAccount) {
    window.pendo.initialize({ visitor: pendoVisitor, account: pendoAccount });
  } else {
    window.pendo.initialize({ visitor: pendoVisitor });
  }
}

export default notifyPendo;
